import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import { Typography } from "@material-ui/core";
import { MobileCardItem, InputSearch, ContainerSearch, MobileContainerAnimation, SwitchStatus } from "../../../..";
import { makeStyles } from "@material-ui/styles";
import { useState } from "react";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    searchContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      paddingTop: "8px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    content: {
      padding: "10px 8px 12px 8px",
      width: "100%"
    },
    search: {
      borderRadius: "60px",
      margin: "0"
    },
    defaultCard: {
      padding: "8px 4px"
    },
    my12: {
      margin: "12px 0"
    },
    inputSearch: {
      borderRadius: "10px",
      margin: "10px 0",
      "box-shadow": "none",
      fontSize: "0.8em"
    }
  };
});

var MobileCampusAnnouncements = function MobileCampusAnnouncements(props) {
  // console.log("MobileCampusAnnouncements props", props);
  var data = props.data,
      translation = props.translation;
  var classes = useStyles();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleSearchChange = function handleSearchChange(event) {
    setValue(event.target.value);
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      props.handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement("div", {
        className: classes.content
      }, /*#__PURE__*/React.createElement("div", {
        className: classes.generalChannel
      }, /*#__PURE__*/React.createElement(MobileCardItem, {
        template: "generalAnnouncementsStaff",
        data: data.rocket_channels.announcements,
        classes: classes.m12,
        translation: translation ? translation.general : null
      })), /*#__PURE__*/React.createElement(Typography, {
        variant: "h6"
      }, translation && translation.groups ? translation.groups.title : "Groups"), /*#__PURE__*/React.createElement(InputSearch, {
        value: value,
        classes: classes.inputSearch,
        onChange: handleSearchChange,
        placeholder: translation && translation.groups ? translation.placeholders.search_group : "Search group"
      }), /*#__PURE__*/React.createElement(ContainerSearch, {
        search: value,
        searchParam: "name",
        options: data.groups,
        template: function template(option) {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            template: "channelListStaff",
            data: option,
            classes: classes.m12
          });
        },
        notFound: function notFound() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            classes: classes.defaultCard
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, translation && translation.groups ? translation.groups.search.not_found : "We didn't find any results"));
        },
        empty: function empty() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            classes: classes.defaultCard
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, translation && translation.groups ? translation.groups.search.no_options : "There are no group created"));
        }
      }));
    }
  }));
};

export { MobileCampusAnnouncements };